import { useState } from 'react'
import PropTypes from 'prop-types'
import { ArrowLeft, ArrowRight } from '@phosphor-icons/react'
import { useTranslation } from 'react-i18next'

import RadioField from '../FormLegacy/FormFieldsV2/RadioField'

import { prepareSubtypeIcons, satisfactionSurvey, singleChoiceSurvey } from './helpers'
import PreviewCheckbox from './PreviewCheckbox'

const AppPreview = ({ type, subtype, questions }) => {
  const { t } = useTranslation(['surveys'])
  const [currentQuestion, setCurrentQuestion] = useState(0)
  const isLastQuestion = currentQuestion + 1 === questions.length || questions.length === 1

  const handleNext = () => !isLastQuestion && setCurrentQuestion(currentQuestion + 1)
  const handleBack = () => currentQuestion && setCurrentQuestion(currentQuestion - 1)
  const prepareContent = () => {
    switch (type) {
      case satisfactionSurvey:
        return prepareSubtypeIcons(t, subtype)
      case singleChoiceSurvey:
        return questions[currentQuestion].answerOptions.map((option, index) => (
          <RadioField key={`${option + index}`} name="option" value={option} label={option} />
        ))
      default:
        return questions[currentQuestion].answerOptions.map((option, index) => (
          <PreviewCheckbox
            key={`${option + index}`}
            name={`${option + index}`}
            value={option}
            label={option}
          />
        ))
    }
  }

  return (
    <div className="app-preview">
      <h3 className="app-preview__title">{questions[currentQuestion].title}</h3>
      <div className="app-preview__content">{prepareContent()}</div>
      <button
        onClick={handleNext}
        className="button app-preview__button app-preview__button--submit"
      >
        {isLastQuestion ? t('surveys:preview.submit') : t('surveys:preview.next')}
        {!isLastQuestion && <ArrowRight size={14} />}
      </button>
      <button
        onClick={handleBack}
        className="button app-preview__button app-preview__button--cancel"
      >
        {!!currentQuestion && <ArrowLeft size={14} />}
        {currentQuestion ? t('surveys:preview.back') : t('surveys:preview.close')}
      </button>
    </div>
  )
}

AppPreview.propTypes = {
  type: PropTypes.string,
  subtype: PropTypes.string,
  questions: PropTypes.array,
}

export default AppPreview
